// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ub2ck","accent":"styles_accent__0vOXZ","accentDull":"styles_accentDull__thZjl","outline":"styles_outline__pK+r1","disabled":"styles_disabled__MMfQ-"};